/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Website_LabelInputs */

const en_company_registration_website_label = /** @type {(inputs: Company_Registration_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_company_registration_website_label = /** @type {(inputs: Company_Registration_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webseite`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Company_Registration_Website_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_website_label = /** @type {((inputs?: Company_Registration_Website_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Website_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_website_label(inputs)
	return en_company_registration_website_label(inputs)
});